import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Grid, Button, Card, CardContent, Switch } from '@mui/material';
import { Page, Header } from 'components';
import ScriptsGenerationDialogForm from './components/ScriptsGenerationDialogForm';

import {
	SetFormState, GetClustersInfo
} from '../actions/ScriptsGenerationActions';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(1),
	},
	tabs: {
		marginTop: theme.spacing(1),
	},
	content: {
		marginTop: theme.spacing(1),
	},
}));

const ScriptsGeneration = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.scriptsGenerationReducer.formState);
	const userId = useSelector(state => state.session.user.id);
	const role = useSelector(state => state.session.user.role);

	useEffect(() => {
		// dispatch(GetClustersInfo(userId));
	}, []);

	return (
		<Page className={classes.root} title="Scripts">
			<Header module="Modules" view="Scripts" />
			<Grid className={classes.container} container spacing={1}>
				<Grid item lg={12} xs={12}>
					<ScriptsGenerationDialogForm />
				</Grid>
			</Grid>
		</Page>
	);
};

export default ScriptsGeneration;
